import React from 'react';

import LayoutViewAppLoading from "./view-app-loading/view-app-loading";

// pohodu eto overlay loading screen dlya item view ....

const debug = false
// const debug = "LayoutViewLoading"

export default class LayoutViewLoading extends React.Component {

    state = {
        display: false
    }

    constructor(props) {
        super(props);

        gd.layout.viewLoading = this;
    }

    showLoading(callback) {
        return new Promise(async (resolve, reject) => {
            this.setState({display: 'loading'},
                () => {
                    setTimeout(()=>{
                        debug && console.log(debug, 'showLoading state has changed')
                        callback && callback()
                        resolve()
                    }, 0)
                }
            )
        })
    }

    // seems like it doesn't work as expected
    async showLoadingAsync() {
        this.setState({display: 'loading'},
            () => {setTimeout(()=>{
                debug && console.log(debug, 'showLoadingAsync state has changed')
                return true
            }, 0)})
    }

    hide() {
        this.setState({
            display: false
        })
    }


    render() {
        switch (this.state.display) {
            case 'loading': return <LayoutViewAppLoading />;
        }

        return false;
    }
}